/* __next_internal_client_entry_do_not_use__ Chevron auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { SVGIcon } from "../SVGIcon";
var DirectionalIcon = styled(SVGIcon).withConfig({
    componentId: "sc-836fb40f-0"
})([
    "transform:rotateZ( ",
    " );"
], function(param) {
    var direction = param.direction;
    switch(direction){
        case "right":
            return "0deg";
        case "down":
            return "90deg";
        case "left":
            return "180deg";
        case "up":
        default:
            return "270deg";
    }
});
export var Chevron = /*#__PURE__*/ React.memo(function(_param) {
    var direction = _param.direction, ref = _param.ref, props = _object_without_properties(_param, [
        "direction",
        "ref"
    ]);
    return /*#__PURE__*/ _jsx(DirectionalIcon, _object_spread_props(_object_spread({
        direction: direction,
        viewBox: "0 0 24 24",
        fill: "none",
        ref: ref
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.60693 0.857147L17.1429 11.3931C17.2228 11.4728 17.2861 11.5674 17.3293 11.6715C17.3725 11.7756 17.3948 11.8873 17.3948 12C17.3948 12.1127 17.3725 12.2244 17.3293 12.3285C17.2861 12.4327 17.2228 12.5272 17.1429 12.6069L6.60693 23.1429",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
});
if ("production" !== "production") {
    Chevron.displayName = "ArrowIcon";
}
